import React, { useState, useEffect } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Form,
  FormGroup,
  Label,
  Input,
  FormFeedback,
} from "reactstrap";

const AddressModal = ({ isOpen, toggle, mode = "add", onSave, address }) => {
  const [formData, setFormData] = useState({
    external_id: "",
    name: "",
    street_address_1: "",
    street_address_2: "",
    city: "",
    state_province: "",
    postal_code: "",
    country: "",
  });

  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (mode === "edit" && address) {
      setFormData({
        external_id: address.external_id || "",
        name: address.name || "",
        street_address_1: address.street_address_1 || "",
        street_address_2: address.street_address_2 || "",
        city: address.city || "",
        state_province: address.state_province || "",
        country: address.country || "",
        postal_code: address.postal_code || "",
      });
    } else if (mode === "add") {
      setFormData({
        external_id: "",
        name: "",
        street_address_1: "",
        street_address_2: "",
        city: "",
        state_province: "",
        postal_code: "",
        country: "",
      });
    }
  }, [mode, address, isOpen]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    setErrors({ ...errors, [name]: "" }); // clear error on change
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    let newErrors = {};
    if (!formData.external_id.trim()) {
      newErrors.external_id = "External ID is required";
    }
    if (!formData.name.trim()) {
      newErrors.name = "Name is required";
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }
      onSave(formData);
      toggle();
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>
        {mode === "edit" ? "Edit Address" : "Add Address"}
      </ModalHeader>
      <Form onSubmit={handleSubmit}>
        <ModalBody>
          <FormGroup>
            <Label for="external_id">External ID *</Label>
            <Input
              type="text"
              name="external_id"
              id="external_id"
              value={formData.external_id}
              onChange={handleChange}
              placeholder="Enter external ID"
              invalid={!!errors.external_id}
            />
            {errors.external_id && <FormFeedback>{errors.external_id}</FormFeedback>}
          </FormGroup>

          <FormGroup>
            <Label for="name">Name *</Label>
            <Input
              type="text"
              name="name"
              id="name"
              value={formData.name}
              onChange={handleChange}
              placeholder="Enter name"
              invalid={!!errors.name}
            />
            {errors.name && <FormFeedback>{errors.name}</FormFeedback>}
          </FormGroup>
          <FormGroup>
            <Label for="street_address_1">Street Address 1</Label>
            <Input
              type="text"
              name="street_address_1"
              id="street_address_1"
              value={formData.street_address_1}
              onChange={handleChange}
              placeholder="Enter street address 1"
            />
          </FormGroup>
        <FormGroup>
            <Label for="street_address_2">Street Address 2</Label>
            <Input
              type="text"
              name="street_address_2"
              id="street_address_2"
              value={formData.street_address_2}
              onChange={handleChange}
              placeholder="Enter street address 2"
            />
          </FormGroup>

          <FormGroup>
            <Label for="city">City</Label>
            <Input
              type="text"
              name="city"
              id="city"
              value={formData.city}
              onChange={handleChange}
              placeholder="Enter city"
            />
          </FormGroup>
          <FormGroup>
            <Label for="state_province">State/Province</Label>
            <Input
              type="text"
              name="state_province"
              id="state_province"
              value={formData.state_province}
              onChange={handleChange}
              placeholder="Enter state"
            />
          </FormGroup>
          <FormGroup>
            <Label for="postal_code">Postal Code</Label>
            <Input
              type="text"
              name="postal_code"
              id="postal_code"
              value={formData.postal_code}
              onChange={handleChange}
              placeholder="Enter postal code"
            />
          </FormGroup>
          <FormGroup>
            <Label for="country">Country</Label>
            <Input
              type="text"
              name="country"
              id="country"
              value={formData.country}
              onChange={handleChange}
              placeholder="Enter country"
            />
          </FormGroup>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={toggle}>
            Cancel
          </Button>
          <Button color="primary" type="submit">
            {mode === "edit" ? "Update" : "Save"}
          </Button>
        </ModalFooter>
      </Form>
    </Modal>
  );
};

export default AddressModal;
